<template>
    <div class="contents">
      <div class="wrap">
        <section>
          <h2 class="page_title --view">약속상품 생산관리</h2>
          <article>
            <ul class="search_filter">
              <li>
                <p>약속상품명</p>
                <input type="text" placeholder="약속상품명을 입력하세요" class="form_control" v-model="searchInfo.wrapperName">
              </li>
              <li>
                <p>상품타입</p>
                <div class="form_select">
                  <b-form-select v-model="searchInfo.goodsType" >
                    <b-form-select-option value="">전체</b-form-select-option>
                    <b-form-select-option v-for="(item, index) in goodsTypeList" :key="index" :value="item.dtl_code">{{item.dtl_code_nm}}</b-form-select-option>
                  </b-form-select>
                </div>
              </li>
              <li>
                <button class="btn btn_md btn_outline" @click="fn_search">조회</button>
              </li>
            </ul>
          </article>
        </section>
        <section class="view">
          <div class="table_list">
            <div class="table_option">
              <div class="form_select"></div>
              <button class="btn btn_md btn_darkblue" @click="fn_move_reg_page">추가 생산</button>
            </div>
            <table class="list no_view">
              <thead>
                <tr>
                    <th>No</th>
                    <th>약속상품명</th>
                    <th>상품타입</th>
                    <th>조제단위</th>
                    <th>재고량</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="promiseGoosWrhsList.length == 0">
                    <td colspan="6"><span>데이터가 없습니다.</span></td>
                </tr>
                <tr v-for="(item, index) in promiseGoosWrhsList" :key="index" :class="{ on:item.promise_goods_cd === choose_wrapper_cd }" @click="fn_promiseGddos_choise(item.promise_goods_cd)">
                  <td><span>{{ index + 1 + ((searchInfo.pageInfo.page-1) * searchInfo.pageInfo.pageSize)  }}</span></td>
                  <td><span>{{ item.promise_goods_nm }}</span></td>
                  <td><span>{{ item.promise_goods_type_nm }}</span></td>
                  <td><span>{{ item.prepare_unit_nm }}</span></td>
                  <td><span>{{ item.promise_goods_whrs }}</span></td>
                </tr>
              </tbody>
            </table>
            <Pagination :pageInfo="searchInfo.pageInfo"  v-show="pagingShow"/>
          </div>
        </section>
      </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import commonUtil from "@/mixin/commonUtil";
    import Pagination from "@/components/AdminPagination.vue"

    export default {
        name: 'PromiseGoodsProductMngt',
        components: {
            Pagination,
        },
        mixins: [commonUtil],
        data() {
        return {
                goodsTypeList : [],       // 상품타입 리스트
                searchInfo : {
                  promiseGoodsNm : '',
                  goodsType : '',
                  pageInfo : {
                    page : 1,
                    pageSize : 10,
                    totPage : 0
                  }                
                },
                choose_wrapper_cd : '',
                pagingShow : false,
                wrapperClassList : [],
                promiseGoosWrhsList: [],
                selected: null
            }
        },
        async created(){
          //공통코드 - 상품타입가져오기
          this.goodsTypeList = await this.getCode('GC00000008');  
          
          let searchInfoStore = this.$store.getters['commonStore/getSearchInfo'];             
          if(searchInfoStore != null && searchInfoStore != {}){
              this.searchInfo = searchInfoStore
          }

          this.fn_search();
        },
        methods : {
            fn_search(){
                console.log("@@@ search : ",this.searchInfo);

                // 검색 정보 저장
                this.$store.dispatch('commonStore/setSearchInfo', this.searchInfo); 

                axios
                    .post("/api/admin/promiseGoodsWrhs/getPromiseGoodsWrhs", this.searchInfo)
                    .then((res) => {
                        console.log("@@@@ res : %o",res);
                        this.promiseGoosWrhsList = res.data.promiseWhrsList;

                        console.log("@@@@ promiseWhrsList : %o",this.promiseWhrsList);

                        this.searchInfo.pageInfo.totPage = res.data.totCnt;
                        
                        if(this.searchInfo.pageInfo.totPage> 0){
                            this.pagingShow = true;                          
                        }                        

                    })
                    .catch((err) => console.log(err));
            },
            // 생산할 약속상품 선택시
            fn_promiseGddos_choise(wrapper_cd){
              this.choose_wrapper_cd = wrapper_cd;
            },
            fn_move_reg_page(){

                if(this.choose_wrapper_cd == ''){
                  alert("제조할 약속상품을 선택하세요");
                }else{
                  this.$store.dispatch('commonStore/setMainCode', this.choose_wrapper_cd);
                  this.$router.push("/admin/promise/promiseGoodsWrhstReg");
                }
            },
            fn_move_dtl_page(wrapperWrhsCd){
                this.$store.dispatch('commonStore/setMainCode', wrapperWrhsCd);
                this.$store.dispatch('commonStore/setStatus', 'M');  
                
                
                this.$router.push("/admin/wrapper/WrapperWrhsMngtReg");			
            },
            fn_delete(wrapperWrhsCd){
                
                let param = new Object();
                param.wrapperWrhsCd = wrapperWrhsCd;

                axios
                    .post("/api/admin/wrapperWrhs/deleteWrapperWrhs", param)
                    .then((res) => {
                        alert("삭제되었습니다");
                        this.fn_search();
                    })
                    .catch((err) => console.log(err));
            }
        }
        
    }
</script>